module.exports = __webpack_public_path__ + "static/media/flask.89c45760.svg";